// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import 'src/tokens/index.css';*/
/*@import 'src/tokens/spacing.css';*/
/*@import 'src/tokens/shapes.css';*/
/*@import 'src/tokens/typography.css';*/


:host {
    font-family: var(--font-family);
    font-size: var(--p2-medium-font-size);
    color: var(--text-default);
}

label {
    color: var(--text-default);
    display: block;
    padding: var(--spacing-05) 0;
}


.combo *,
.combo *::before,
.combo *::after {
    box-sizing: border-box;
}

.combo {
    display: block;
    /*from figma*/
    min-width: var(--input-min-width);
    position: relative;
    cursor: default;
    /*width: fit-content;*/
}

/**/
.combo::after {
    border-bottom: 2px solid var(--icon-light);
    border-right: 2px solid var(--icon-light);
    content: "";
    display: block;
    height: 6px;
    pointer-events: none;
    position: absolute;
    right: var(--spacing-20);
    top: 50%;
    transform: translate(0, -65%) rotate(45deg);
    width: 6px;
}
.combo:hover {
    cursor: pointer;
}
/*swift.com use custom color*/
/*.combo:hover::after {*/
/*    border-color: #01a990;*/
/*}*/
[role="combobox"] {
    align-items: center;
    background-color: var(--background-white);
    border: 1px solid var(--border-strong);
    border-radius: var(--spacing-05);
    display: flex;
    height: var(--spacing-50);
    padding: var(--spacing-05) var(--spacing-10);
    text-align: left;
}

[role="combobox"]:empty::after {
/*.combo-input::after {*/
    /*content: var(--placeholder);*/
    content: attr(data-placeholder) "";
    color: var(--text-placeholder);
    font-size: var(--p2-regular-font-size);
    font-family: var(--p2-regular-font-family), sans-serif;
}
[role="combobox"]:focus {
    outline: 1px solid var(--border-focused);
}



/*options*/
[role="listbox"] {
    background-color: var(--background-white);
    border: 1px solid var(--border-light);
    border-radius: var(--spacing-05);
    display: none;
    max-height: 300px;
    overflow-y: auto;
    left: 0;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 100;
    margin-top: var(--spacing-05);
    /*padding-top: var(--spacing-05);*/
    /*padding-bottom: var(--spacing-05);*/
    box-shadow: 0 1px 8px 2px var(--border-light);
}

.open [role="listbox"] {
    display: block;
}

[role="option"] {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: var(--spacing-40);
    padding: 0 var(--spacing-20);
}

[role="option"]:hover {
    background-color: var(--accent-light-hover);
}

/*[role="option"].option-current {*/
/*[role="option"][aria-selected="true"] {*/
/*    background-color: var(--accent-light-selected);*/
/*    !*outline-offset: -3px;*!*/
/*}*/

[role="option"][aria-selected="true"] {
    background-color: var(--accent-light-selected);
    padding-right: 30px;
    position: relative;
}

[role="option"][aria-selected="true"]::after {
    border-bottom: 2px solid var(--text-light);
    border-right: 2px solid var(--text-light);
    content: "";
    height: 10px;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translate(0, -50%) rotate(45deg);
    width: 7px;
}


.message {
    color: var(--text-placeholder);
    font-size: var(--p2-regular-font-size);
}


:host([kind="light"]) [role="combobox"] {
    border-color: transparent;
}
:host([kind="light"]) [role="combobox"]:focus {
    outline: none;
    /*border-color: transparent;*/
}
/*:host([kind="light"]) [role="listbox"] {*/
/*    border-color: transparent;*/
/*    box-shadow: none;*/
/*}*/
/*:host([kind="light"]) [role="option"][aria-selected="true"]::after {*/
/*    border: none;*/
/*}*/
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/dropdown/style/index.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,oCAAoC;AACpC,mCAAmC;AACnC,uCAAuC;;;AAGvC;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,4BAA4B;AAChC;;;AAGA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA,GAAG;AACH;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,WAAW;IACX,cAAc;IACd,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,QAAQ;IACR,2CAA2C;IAC3C,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA,6BAA6B;AAC7B,wBAAwB;AACxB,6BAA6B;AAC7B,IAAI;AACJ;IACI,mBAAmB;IACnB,yCAAyC;IACzC,sCAAsC;IACtC,gCAAgC;IAChC,aAAa;IACb,yBAAyB;IACzB,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;AACA,wBAAwB;IACpB,+BAA+B;IAC/B,kCAAkC;IAClC,8BAA8B;IAC9B,sCAAsC;IACtC,sDAAsD;AAC1D;AACA;IACI,wCAAwC;AAC5C;;;;AAIA,UAAU;AACV;IACI,yCAAyC;IACzC,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,OAAO;IACP,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kCAAkC;IAClC,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,mCAAmC;AACnC,0CAA0C;AAC1C,sDAAsD;AACtD,gCAAgC;AAChC,IAAI;;AAEJ;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2CAA2C;IAC3C,UAAU;AACd;;;AAGA;IACI,8BAA8B;IAC9B,sCAAsC;AAC1C;;;AAGA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,6BAA6B;AACjC;AACA,2CAA2C;AAC3C,iCAAiC;AACjC,wBAAwB;AACxB,IAAI;AACJ,uEAAuE;AACvE,oBAAoB;AACpB,IAAI","sourcesContent":["/*@import 'src/tokens/index.css';*/\n/*@import 'src/tokens/spacing.css';*/\n/*@import 'src/tokens/shapes.css';*/\n/*@import 'src/tokens/typography.css';*/\n\n\n:host {\n    font-family: var(--font-family);\n    font-size: var(--p2-medium-font-size);\n    color: var(--text-default);\n}\n\nlabel {\n    color: var(--text-default);\n    display: block;\n    padding: var(--spacing-05) 0;\n}\n\n\n.combo *,\n.combo *::before,\n.combo *::after {\n    box-sizing: border-box;\n}\n\n.combo {\n    display: block;\n    /*from figma*/\n    min-width: var(--input-min-width);\n    position: relative;\n    cursor: default;\n    /*width: fit-content;*/\n}\n\n/**/\n.combo::after {\n    border-bottom: 2px solid var(--icon-light);\n    border-right: 2px solid var(--icon-light);\n    content: \"\";\n    display: block;\n    height: 6px;\n    pointer-events: none;\n    position: absolute;\n    right: var(--spacing-20);\n    top: 50%;\n    transform: translate(0, -65%) rotate(45deg);\n    width: 6px;\n}\n.combo:hover {\n    cursor: pointer;\n}\n/*swift.com use custom color*/\n/*.combo:hover::after {*/\n/*    border-color: #01a990;*/\n/*}*/\n[role=\"combobox\"] {\n    align-items: center;\n    background-color: var(--background-white);\n    border: 1px solid var(--border-strong);\n    border-radius: var(--spacing-05);\n    display: flex;\n    height: var(--spacing-50);\n    padding: var(--spacing-05) var(--spacing-10);\n    text-align: left;\n}\n\n[role=\"combobox\"]:empty::after {\n/*.combo-input::after {*/\n    /*content: var(--placeholder);*/\n    content: attr(data-placeholder) \"\";\n    color: var(--text-placeholder);\n    font-size: var(--p2-regular-font-size);\n    font-family: var(--p2-regular-font-family), sans-serif;\n}\n[role=\"combobox\"]:focus {\n    outline: 1px solid var(--border-focused);\n}\n\n\n\n/*options*/\n[role=\"listbox\"] {\n    background-color: var(--background-white);\n    border: 1px solid var(--border-light);\n    border-radius: var(--spacing-05);\n    display: none;\n    max-height: 300px;\n    overflow-y: auto;\n    left: 0;\n    position: absolute;\n    top: 100%;\n    width: 100%;\n    z-index: 100;\n    margin-top: var(--spacing-05);\n    /*padding-top: var(--spacing-05);*/\n    /*padding-bottom: var(--spacing-05);*/\n    box-shadow: 0 1px 8px 2px var(--border-light);\n}\n\n.open [role=\"listbox\"] {\n    display: block;\n}\n\n[role=\"option\"] {\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    height: var(--spacing-40);\n    padding: 0 var(--spacing-20);\n}\n\n[role=\"option\"]:hover {\n    background-color: var(--accent-light-hover);\n}\n\n/*[role=\"option\"].option-current {*/\n/*[role=\"option\"][aria-selected=\"true\"] {*/\n/*    background-color: var(--accent-light-selected);*/\n/*    !*outline-offset: -3px;*!*/\n/*}*/\n\n[role=\"option\"][aria-selected=\"true\"] {\n    background-color: var(--accent-light-selected);\n    padding-right: 30px;\n    position: relative;\n}\n\n[role=\"option\"][aria-selected=\"true\"]::after {\n    border-bottom: 2px solid var(--text-light);\n    border-right: 2px solid var(--text-light);\n    content: \"\";\n    height: 10px;\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translate(0, -50%) rotate(45deg);\n    width: 7px;\n}\n\n\n.message {\n    color: var(--text-placeholder);\n    font-size: var(--p2-regular-font-size);\n}\n\n\n:host([kind=\"light\"]) [role=\"combobox\"] {\n    border-color: transparent;\n}\n:host([kind=\"light\"]) [role=\"combobox\"]:focus {\n    outline: none;\n    /*border-color: transparent;*/\n}\n/*:host([kind=\"light\"]) [role=\"listbox\"] {*/\n/*    border-color: transparent;*/\n/*    box-shadow: none;*/\n/*}*/\n/*:host([kind=\"light\"]) [role=\"option\"][aria-selected=\"true\"]::after {*/\n/*    border: none;*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
